module.exports = __webpack_public_path__ + "img/rust-in-the-root.98f10ee3.png";